import React, { createContext, useContext, useState } from 'react';

/* eslint-disable @typescript-eslint/no-explicit-any */

interface ModalContextType {
  openModal: (id: string, data?: any) => void;
  closeModal: (id: string) => void;
  isOpen: (id: string) => boolean;
  modalData: any;
}

const ModalContext = createContext<ModalContextType | null>(null);

export const ModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [openModals, setOpenModals] = useState<Record<string, boolean>>({});
  const [modalData, setModalData] = useState<any>(null);

  const openModal = (id: string, data?: any) => {
    setOpenModals((prev) => ({ ...prev, [id]: true }));
    if (data) setModalData(data);
  };

  const closeModal = (id: string) => {
    setOpenModals((prev) => ({ ...prev, [id]: false }));
    setModalData(null);
  };

  const isOpen = (id: string) => !!openModals[id];

  return (
    <ModalContext.Provider value={{ openModal, closeModal, isOpen, modalData }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = (): ModalContextType => {
  const context = useContext(ModalContext);
  if (!context) throw new Error('useModal must be used within ModalProvider');
  return context;
};
